/**
 * newVersion.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
**/

import * as React from "react";
//import MDDialog from "@mui/material/Dialog";
import { DialogContent, DialogActions, DialogTitle, Button, Snackbar, SnackbarContent } from "@mui/material";

import { workerServiceFactory } from "../services/worker.service";
import { AuthContext } from "../auth/auth.context";
import { Brand } from "../models/brand";

interface Props {
  open: boolean,
  onClose(): void
}

export function NewVersionNotificationComponent(props: Props): React.ReactElement<any, any> {
  const [isInstalling, setInstalling] = React.useState<boolean>(false);
  const authContext = React.useContext(AuthContext);

  async function doReload() {
    setInstalling(true);
    try {
      await workerServiceFactory().activateNewWorker();
      window.location.reload();
    } catch (err) {
      console.error("Error activating worker:", err);
    }
  }

  const brand = authContext.brand === Brand.WORKSPACE ? "Mercury Workspace" : "Glyph";
  const content = <>
    <DialogTitle>We've Upgraded!</DialogTitle>
    <DialogContent>
      <p>A new version of {brand} is available.<br />
        Please, reload your browser.</p>
      <p></p>
    </DialogContent>
    <DialogActions>
      <Button color="primary" variant="contained"
        disableRipple disableTouchRipple
        disabled={isInstalling}
        onClick={doReload}>
        {isInstalling ? "Installing" : "Reload"}
      </Button>
    </DialogActions>
  </>;

  return props.open ? <Snackbar open={props.open}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    onClose={() => { props.onClose(); }} >
    <SnackbarContent message={content} />
  </Snackbar> : <></>;
}